import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {from, Observable, of, ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {
  CONTRACT_OWNER_PARTNER,
  CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
  CONTRACT_TYPE_FRANCHISE,
  CONTRACT_TYPE_FRANCHISE_AGREEMENT,
  DICT_TYPE_FORM_OF_BUSINESS,
  DictService,
  FILE_EXTENSION_DOCX,
  FILE_EXTENSION_XLSX,
  FORM_OF_BUSINESS_ASSOCIATION,
  FORM_OF_BUSINESS_COOPERATIVE,
  FORM_OF_BUSINESS_FOREIGN_ACTIVITIES,
  FORM_OF_BUSINESS_GENERAL_PARTNERSHIP,
  FORM_OF_BUSINESS_JOINT_STOCK_COMPANY,
  FORM_OF_BUSINESS_LIMITED_LIABILITY_PARTNERSHIP,
  FORM_OF_BUSINESS_LIMITED_PARTNERSHIP,
  FORM_OF_BUSINESS_PARTNERSHIP,
  FORM_OF_BUSINESS_PARTNERSHIP_LIMITED_BY_SHARES,
  FORM_OF_BUSINESS_PRIVATE_LIMITED_COMPANY,
  FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP,
  GENERATED_EMPTY,
  GENERATED_FIELDS_SEPARATOR,
  LEGAL_FORM_NATURAL_PERSON,
  TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY,
  TEMPLATE_TYPE_ANNEX_COMMISSION_ATTACHMENT,
  TEMPLATE_TYPE_ANNEX_LEAD_TEMPLATE,
  TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
  TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION,
  TEMPLATE_TYPE_AUTHORIZATION,
  TEMPLATE_TYPE_CONFIDENTIALITY_AGREEMENT,
  TEMPLATE_TYPE_CONTRACT,
  TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE,
  TEMPLATE_TYPE_DECLARATION_FOR_DEREGISTRATION,
  TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION,
  TEMPLATE_TYPE_OFWCA_APPLICATION,
  TEMPLATE_TYPE_PARTNER_DATA,
  TEMPLATE_TYPE_STATEMENT,
  TEMPLATE_TYPE_TERMINATION,
  TEMPLATE_TYPE_PERSONAL_DATA_CHANGE,
  FORM_OF_BUSINESS_NONE_PROPRIETORSHIP,
  TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING,
  TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING
} from '../../../shared/services/dict.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {Router} from '@angular/router';
import {FileInput, FileValidator} from 'ngx-material-file-input';
import {delay, filter, first, skipUntil, take, takeUntil, tap} from 'rxjs/operators';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {Template} from '../../../shared/interface/template';
import {TemplateService} from '../../../shared/services/template.service';
import {Dictionary} from '../../../shared/interface/dictionary';

@Component({
  selector: 'app-template-add',
  templateUrl: './template-add.component.html',
  styleUrls: ['./template-add.component.scss']
})
export class TemplateAddComponent implements OnInit, OnDestroy {
  @Input() template?: Observable<Template>;
  @Input() templateObject?: Template;
  @Output() closeModification = new EventEmitter<any>();

  readonly FORM_OF_BUSINESS_LEGAL_PERSON = [
    FORM_OF_BUSINESS_PARTNERSHIP,
    FORM_OF_BUSINESS_COOPERATIVE,
    FORM_OF_BUSINESS_GENERAL_PARTNERSHIP,
    FORM_OF_BUSINESS_LIMITED_LIABILITY_PARTNERSHIP,
    FORM_OF_BUSINESS_LIMITED_PARTNERSHIP,
    FORM_OF_BUSINESS_PARTNERSHIP_LIMITED_BY_SHARES,
    FORM_OF_BUSINESS_JOINT_STOCK_COMPANY,
    FORM_OF_BUSINESS_PRIVATE_LIMITED_COMPANY,
    FORM_OF_BUSINESS_FOREIGN_ACTIVITIES,
    FORM_OF_BUSINESS_ASSOCIATION
  ];
  readonly GENERATED_FIELDS_SEPARATOR = GENERATED_FIELDS_SEPARATOR;
  readonly FILE_EXTENSION_DOCX = FILE_EXTENSION_DOCX;
  readonly GENERATED_EMPTY = GENERATED_EMPTY;
  readonly FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP = FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP;
  readonly FORM_OF_BUSINESS_NONE_PROPRIETORSHIP = FORM_OF_BUSINESS_NONE_PROPRIETORSHIP;
  readonly TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING = TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING;
  readonly TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING = TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING;


  fileMaxSize = 5242880;
  templateForm: FormGroup;
  templateTypeControl: FormControl;
  fileControl: FormControl;
  fileContentControl: FormControl;
  contractTypeControl: FormControl;
  companyControl: FormControl;
  legalFormControl: FormControl;
  ownerControl: FormControl;
  insuranceCompanyControl: FormControl;
  companiesControl: FormControl;
  generatedFieldsControl: FormControl;
  generatedFieldsNameControl: FormControl;
  fileExtensionControl: FormControl;
  terminationTypeControl: FormControl;
  annexControl: FormControl;
  validFromControl: FormControl;
  formOfBusinessControl: FormControl;
  processingRequest = false;
  requireContractDataFields = false;
  requireContractAnnexDataFields = false;
  requireRegistrationDataFields = false;
  requireAuthorizationDataFields = false;
  requireFileConfigurationDataFields = false;
  requireLegalForm = false;
  requireTerminationTypeDataFields = false;
  requireOfwcaApplicationDataFields = false;
  legalFormLegal = true;
  formErrors = {};
  templateFormValid = false;
  requirePartnerDataFields = false;
  startingFieldDataFields = false;
  sortItems: [Dictionary[]] = [[]];
  items: Dictionary[] = [];
  selectedValues = [];
  selectedValuesName = [];
  fileType: string;
  requirePersonalDataChange = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private dictService: DictService,
    private templateService: TemplateService,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private router: Router,
  ) {
    this.templateForm = fb.group({
      file: this.fileControl = fb.control('', [Validators.required, FileValidator.maxContentSize(this.fileMaxSize)]),
      name: fb.control('', [Validators.required]),
      fileContent: this.fileContentControl = fb.control('', [Validators.required]),
      type: this.templateTypeControl = fb.control('', [Validators.required]),
      contractType: this.contractTypeControl = fb.control('', []),
      company: this.companyControl = fb.control('', []),
      legalForm: this.legalFormControl = fb.control('', []),
      owner: this.ownerControl = fb.control('', []),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', []),
      companies: this.companiesControl = fb.control([], []),
      generatedFields: this.generatedFieldsControl = fb.control([], []),
      generatedFieldsName: this.generatedFieldsNameControl = fb.control([], []),
      fileExtension: this.fileExtensionControl = fb.control('', []),
      terminationType: this.terminationTypeControl = fb.control('', []),
      annex: this.annexControl = fb.control(false),
      formOfBusiness: this.formOfBusinessControl = fb.control('',[]),
      startingFieldX: fb.control('', []),
      startingFieldY: fb.control('', []),
      validFrom: this.validFromControl = fb.control('', []),
    });
    this.validFromControl.disable();
  }

  ngOnInit(): void {
    this.templateForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.templateFormValid = this.templateForm.valid);

    this.templateForm.get('file').valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: FileInput) => !!file)
      )
      .subscribe((file: FileInput) => {
        this.templateForm.get('name').setValue(file.fileNames);

        const reader = new FileReader();
        reader.readAsDataURL(file.files[0]);
        reader.onload = () => {
          this.templateForm.get('fileContent').setValue(/base64,(.+)/.exec(reader.result.toString())[1]);
        };
      });

    this.templateTypeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((templateTypeId: number) => {
        this.dictService.getKey(templateTypeId)
          .subscribe((dictKey: string) => {

            if ([
              TEMPLATE_TYPE_CONFIDENTIALITY_AGREEMENT,
            ].includes(dictKey)) {
              this.resetRequirements();
            }
            if ([
              TEMPLATE_TYPE_CONTRACT,
            ].includes(dictKey)) {
              this.requireContractData();
            }

            if ([
              TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION,
              TEMPLATE_TYPE_ANNEX_COMMISSION_ATTACHMENT,
              TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
              TEMPLATE_TYPE_ANNEX_LEAD_TEMPLATE,
              TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING,
              TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING
            ].includes(dictKey)) {
              this.requireContractAnnexData();
            }

            if ([TEMPLATE_TYPE_TERMINATION].includes(dictKey)) {
              this.requireTerminationData();
            }

            if ([TEMPLATE_TYPE_STATEMENT, TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY].includes(dictKey)) {
              this.requireRegistrationData();
            }

            if ([TEMPLATE_TYPE_DECLARATION_FOR_DEREGISTRATION].includes(dictKey)) {
              this.requireFileConfigurationData();
            }

            if ([TEMPLATE_TYPE_AUTHORIZATION].includes(dictKey)) {
              this.requireAuthorizationData();
            }

            if ([TEMPLATE_TYPE_PERSONAL_DATA_CHANGE].includes(dictKey)) {
              this.requirePersonalDataChangeFields();
            }

            if ([TEMPLATE_TYPE_PARTNER_DATA].includes(dictKey)) {
              this.requirePartnerData();
            }

            if ([TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY].includes(dictKey)) {
              this.validFromControl.enable();
              this.validFromControl.setValidators([Validators.required]);
              this.validFromControl.updateValueAndValidity();
            } else {
              this.validFromControl.disable();
              this.validFromControl.setValidators([]);
              this.validFromControl.updateValueAndValidity();
            }

            if ([TEMPLATE_TYPE_OFWCA_APPLICATION,
              TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE,
              TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION].includes(dictKey)) {
              this.requireOfwcaApplicationData();
            }
          });
    });

    this.ownerControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      ).subscribe((ownerId: number) => {
        this.dictService.getKey(ownerId)
          .subscribe((dictKey: string) => {
            if (dictKey === CONTRACT_OWNER_PARTNER) {
              this.requireLegalForm = true;
              this.legalFormControl.setValidators([Validators.required]);
              this.formOfBusinessControl.setValidators([Validators.required]);
            } else {
              this.requireLegalForm = false;
              this.legalFormControl.setValidators([]);
              this.formOfBusinessControl.setValidators([]);
              this.formOfBusinessControl.reset();
              this.legalFormControl.reset();
            }
          });
    });

    this.fileExtensionControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            if (dictKey === FILE_EXTENSION_XLSX) {
              this.templateForm.get('startingFieldX').setValidators([Validators.required]);
              this.templateForm.get('startingFieldX').updateValueAndValidity();
              this.templateForm.get('startingFieldY').setValidators([Validators.required]);
              this.templateForm.get('startingFieldY').updateValueAndValidity();
              this.startingFieldDataFields = true;
            } else {
              this.templateForm.get('startingFieldX').reset();
              this.templateForm.get('startingFieldX').setValidators([]);
              this.templateForm.get('startingFieldX').updateValueAndValidity();
              this.templateForm.get('startingFieldY').reset();
              this.templateForm.get('startingFieldY').setValidators([]);
              this.templateForm.get('startingFieldY').updateValueAndValidity();
              this.startingFieldDataFields = false;
            }
          });
      });

    this.legalFormControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            if (dictKey === LEGAL_FORM_NATURAL_PERSON) {
              // this.dictService.getId(FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP, DICT_TYPE_FORM_OF_BUSINESS)
              //   .subscribe((resultDictId: number) => {
              //     this.formOfBusinessControl.setValue(resultDictId);
              //   });
              //
              // this.formOfBusinessControl.disable();
              this.legalFormLegal = false;

            } else {
              // this.formOfBusinessControl.enable();
              this.legalFormLegal = true;
            }
          });
      });

    if (this.template) {
      this.template
        .pipe(takeUntil(this.destroyed$))
        .subscribe((template: Template) => {
          this.initialize(template);
          this.templateObject = template;
        });
    }
  }

  initialize(template: Template): void {
    of(template)
      .pipe(
        delay(0),
        tap(() => {
          this.fileControl.setValidators([FileValidator.maxContentSize(this.fileMaxSize)]);
          this.fileContentControl.setValidators([]);
        if (template.generatedFields) {
          this.selectedValues = template.generatedFields.split(',');
          this.generatedFieldsControl.setValue(this.selectedValues.toString());
        }
        if (template.generatedFieldsName) {
          this.selectedValuesName = template.generatedFieldsName.split(',');
          this.generatedFieldsNameControl.setValue(this.selectedValuesName.toString());
        }

          this.templateForm.reset({
            name: template.name,
            type: template.type?.id,
            insuranceCompany: template.insuranceCompany?.id,
            companies: template.companies.map((company: Dictionary) => company.id),
            contractType: template.contractType?.id,
            company: template.company?.id,
            legalForm: template.legalForm?.id,
            owner: template.owner?.id,
            annex: template.annex,
            formOfBusiness: template.formOfBusiness?.id,
            fileExtension: template.fileExtension?.id,
            generatedFields: template.generatedFields,
            generatedFieldsName: template.generatedFieldsName,
            startingFieldX: template.startingFieldX,
            startingFieldY: template.startingFieldY,
            validFrom: template.validFrom,
          });
          if (template.formOfBusiness?.key === LEGAL_FORM_NATURAL_PERSON) {
            this.dictService.getId(FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP, DICT_TYPE_FORM_OF_BUSINESS)
              .subscribe((resultDictId: number) => {
                this.formOfBusinessControl.setValue(resultDictId);
              });

            this.formOfBusinessControl.disable();
            this.legalFormLegal = false;

          }
        }),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  resetRequirements(): void {
    this.requireContractDataFields = false;
    this.requireRegistrationDataFields = false;
    this.requireAuthorizationDataFields = false;
    this.requireTerminationTypeDataFields = false;
    this.requireContractAnnexDataFields = false;
    this.requireOfwcaApplicationDataFields = false;
    this.requirePartnerDataFields = false;
    this.requireFileConfigurationDataFields = false;
    this.templateForm.get('startingFieldX').reset();
    this.templateForm.get('startingFieldX').setValidators([]);
    this.templateForm.get('startingFieldX').updateValueAndValidity();
    this.templateForm.get('startingFieldY').reset();
    this.templateForm.get('startingFieldY').setValidators([]);
    this.templateForm.get('startingFieldY').updateValueAndValidity();
    this.contractTypeControl.reset();
    this.companyControl.reset();
    this.fileExtensionControl.reset();
    this.legalFormControl.reset();
    this.ownerControl.reset();
    this.insuranceCompanyControl.reset();
    this.companiesControl.reset();
    this.generatedFieldsControl.reset();
    this.generatedFieldsNameControl.reset();
    this.generatedFieldsNameControl.setValidators([]);
    this.generatedFieldsNameControl.updateValueAndValidity();
    this.terminationTypeControl.reset();
    this.formOfBusinessControl.reset();
    this.annexControl.reset();
    this.contractTypeControl.setValidators([]);
    this.companyControl.setValidators([]);
    this.ownerControl.setValidators([]);
    this.insuranceCompanyControl.setValidators([]);
    this.companiesControl.setValidators([]);
    this.generatedFieldsControl.setValidators([]);
    this.terminationTypeControl.setValidators([]);
    this.fileExtensionControl.setValidators([]);
    this.formOfBusinessControl.setValidators([]);
    this.legalFormControl.setValidators([]);
    this.annexControl.setValidators([]);
    this.contractTypeControl.updateValueAndValidity();
    this.companyControl.updateValueAndValidity();
    this.ownerControl.updateValueAndValidity();
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.generatedFieldsControl.updateValueAndValidity();
    this.fileExtensionControl.updateValueAndValidity();
    this.terminationTypeControl.updateValueAndValidity();
    this.formOfBusinessControl.updateValueAndValidity();
    this.legalFormControl.updateValueAndValidity();
    this.annexControl.updateValueAndValidity();
  }

  requireContractData(): void {
    this.requireContractDataFields = true;
    this.requireRegistrationDataFields = false;
    this.requireAuthorizationDataFields = false;
    this.requireTerminationTypeDataFields = false;
    this.requireContractAnnexDataFields = false;
    this.requireOfwcaApplicationDataFields = false;
    this.requirePartnerDataFields = false;
    this.requireFileConfigurationDataFields = false;
    this.contractTypeControl.setValidators([Validators.required]);
    this.companyControl.setValidators([Validators.required]);
    this.ownerControl.setValidators([Validators.required]);
    this.insuranceCompanyControl.reset();
    this.companiesControl.reset();
    this.generatedFieldsControl.reset();
    this.generatedFieldsNameControl.reset();
    this.generatedFieldsNameControl.setValidators([]);
    this.generatedFieldsNameControl.updateValueAndValidity();
    this.fileExtensionControl.reset();
    this.annexControl.reset();
    this.insuranceCompanyControl.setValidators([]);
    this.companiesControl.setValidators([]);
    this.generatedFieldsControl.setValidators([]);
    this.fileExtensionControl.setValidators([]);
    this.terminationTypeControl.setValidators([]);
    this.formOfBusinessControl.setValidators([]);
    this.legalFormControl.setValidators([]);
    this.annexControl.setValidators([]);
    this.contractTypeControl.updateValueAndValidity();
    this.companyControl.updateValueAndValidity();
    this.ownerControl.updateValueAndValidity();
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.generatedFieldsControl.updateValueAndValidity();
    this.fileExtensionControl.updateValueAndValidity();
    this.terminationTypeControl.updateValueAndValidity();
    this.formOfBusinessControl.updateValueAndValidity();
    this.legalFormControl.updateValueAndValidity();
    this.annexControl.updateValueAndValidity();
    this.templateForm.get('startingFieldX').reset();
    this.templateForm.get('startingFieldX').setValidators([]);
    this.templateForm.get('startingFieldX').updateValueAndValidity();
    this.templateForm.get('startingFieldY').reset();
    this.templateForm.get('startingFieldY').setValidators([]);
    this.templateForm.get('startingFieldY').updateValueAndValidity();
  }

  requireContractAnnexData(): void {
    this.requireContractAnnexDataFields = true;
    this.requireContractDataFields = false;
    this.requireRegistrationDataFields = false;
    this.requireAuthorizationDataFields = false;
    this.requireTerminationTypeDataFields = false;
    this.requireOfwcaApplicationDataFields = false;
    this.requirePartnerDataFields = false;
    this.requireFileConfigurationDataFields = false;
    this.contractTypeControl.setValidators([Validators.required]);
    this.companyControl.setValidators([Validators.required]);
    this.ownerControl.setValidators([Validators.required]);
    this.insuranceCompanyControl.reset();
    this.companiesControl.reset();
    this.generatedFieldsControl.reset();
    this.generatedFieldsNameControl.reset();
    this.generatedFieldsNameControl.setValidators([]);
    this.generatedFieldsNameControl.updateValueAndValidity();
    this.fileExtensionControl.reset();
    this.annexControl.reset();
    this.insuranceCompanyControl.setValidators([]);
    this.companiesControl.setValidators([]);
    this.generatedFieldsControl.setValidators([]);
    this.fileExtensionControl.setValidators([]);
    this.terminationTypeControl.setValidators([]);
    this.formOfBusinessControl.setValidators([]);
    this.legalFormControl.setValidators([]);
    this.annexControl.setValidators([]);
    this.contractTypeControl.updateValueAndValidity();
    this.companyControl.updateValueAndValidity();
    this.ownerControl.updateValueAndValidity();
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.generatedFieldsControl.updateValueAndValidity();
    this.fileExtensionControl.updateValueAndValidity();
    this.terminationTypeControl.updateValueAndValidity();
    this.formOfBusinessControl.updateValueAndValidity();
    this.legalFormControl.updateValueAndValidity();
    this.annexControl.updateValueAndValidity();
    this.templateForm.get('startingFieldX').reset();
    this.templateForm.get('startingFieldX').setValidators([]);
    this.templateForm.get('startingFieldX').updateValueAndValidity();
    this.templateForm.get('startingFieldY').reset();
    this.templateForm.get('startingFieldY').setValidators([]);
    this.templateForm.get('startingFieldY').updateValueAndValidity();
  }

  requirePartnerData(): void {
    this.requirePartnerDataFields = true;
    this.requireContractDataFields = false;
    this.requireRegistrationDataFields = false;
    this.requireAuthorizationDataFields = false;
    this.requireTerminationTypeDataFields = false;
    this.requireContractAnnexDataFields = false;
    this.requireOfwcaApplicationDataFields = false;
    this.requireFileConfigurationDataFields = false;
    this.legalFormControl.setValidators([Validators.required]);
    this.contractTypeControl.reset();
    this.companyControl.reset();
    this.ownerControl.reset();
    this.insuranceCompanyControl.reset();
    this.companiesControl.reset();
    this.generatedFieldsControl.reset();
    this.generatedFieldsNameControl.reset();
    this.generatedFieldsNameControl.setValidators([]);
    this.generatedFieldsNameControl.updateValueAndValidity();
    this.fileExtensionControl.reset();
    this.terminationTypeControl.reset();
    this.formOfBusinessControl.reset();
    this.annexControl.reset();
    this.contractTypeControl.setValidators([]);
    this.companyControl.setValidators([]);
    this.ownerControl.setValidators([]);
    this.insuranceCompanyControl.setValidators([]);
    this.companiesControl.setValidators([]);
    this.generatedFieldsControl.setValidators([]);
    this.fileExtensionControl.setValidators([]);
    this.terminationTypeControl.setValidators([]);
    this.formOfBusinessControl.setValidators([]);
    this.annexControl.setValidators([]);
    this.legalFormControl.updateValueAndValidity();
    this.contractTypeControl.updateValueAndValidity();
    this.companyControl.updateValueAndValidity();
    this.ownerControl.updateValueAndValidity();
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.generatedFieldsControl.updateValueAndValidity();
    this.fileExtensionControl.updateValueAndValidity();
    this.terminationTypeControl.updateValueAndValidity();
    this.formOfBusinessControl.updateValueAndValidity();
    this.annexControl.updateValueAndValidity();
    this.templateForm.get('startingFieldX').reset();
    this.templateForm.get('startingFieldX').setValidators([]);
    this.templateForm.get('startingFieldX').updateValueAndValidity();
    this.templateForm.get('startingFieldY').reset();
    this.templateForm.get('startingFieldY').setValidators([]);
    this.templateForm.get('startingFieldY').updateValueAndValidity();
  }

  requireTerminationData(): void {
    this.requireContractData();
    this.requireTerminationTypeDataFields = true;
    this.terminationTypeControl.setValidators([Validators.required]);
    this.terminationTypeControl.updateValueAndValidity();

  }

  requireRegistrationData(): void {
    this.requireRegistrationDataFields = true;
    this.insuranceCompanyControl.setValidators([Validators.required]);
    this.companiesControl.setValidators([Validators.required]);
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.requireContractDataFields = false;
    this.requireAuthorizationDataFields = false;
    this.requireTerminationTypeDataFields = false;
    this.requireContractAnnexDataFields = false;
    this.requireOfwcaApplicationDataFields = false;
    this.requirePartnerDataFields = false;
    this.requireFileConfigurationDataFields = false;
    // this.contractTypeControl.reset();
    this.companyControl.reset();
    this.legalFormControl.reset();
    this.ownerControl.reset();
    this.terminationTypeControl.reset();
    this.formOfBusinessControl.reset();
    this.generatedFieldsControl.reset();
    this.generatedFieldsNameControl.reset();
    this.generatedFieldsNameControl.setValidators([]);
    this.generatedFieldsNameControl.updateValueAndValidity();
    this.fileExtensionControl.reset();
    this.annexControl.reset();
    this.contractTypeControl.setValidators([]);
    this.companyControl.setValidators([]);
    this.ownerControl.setValidators([]);
    this.terminationTypeControl.setValidators([]);
    this.formOfBusinessControl.setValidators([]);
    this.generatedFieldsControl.setValidators([]);
    this.fileExtensionControl.setValidators([]);
    this.legalFormControl.setValidators([]);
    this.annexControl.setValidators([]);
    this.contractTypeControl.updateValueAndValidity();
    this.companyControl.updateValueAndValidity();
    this.ownerControl.updateValueAndValidity();
    this.terminationTypeControl.updateValueAndValidity();
    this.formOfBusinessControl.updateValueAndValidity();
    this.legalFormControl.updateValueAndValidity();
    this.annexControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.fileExtensionControl.updateValueAndValidity();
    this.templateForm.get('startingFieldX').reset();
    this.templateForm.get('startingFieldX').setValidators([]);
    this.templateForm.get('startingFieldX').updateValueAndValidity();
    this.templateForm.get('startingFieldY').reset();
    this.templateForm.get('startingFieldY').setValidators([]);
    this.templateForm.get('startingFieldY').updateValueAndValidity();
  }

  requireFileConfigurationData(): void {
    this.loadItems("generated_fields");
    this.requireFileConfigurationDataFields = true;
    this.insuranceCompanyControl.setValidators([Validators.required]);
    this.companyControl.setValidators([Validators.required]);
    this.generatedFieldsControl.setValidators([Validators.required]);
    this.generatedFieldsNameControl.setValidators([]);
    this.fileExtensionControl.setValidators([Validators.required]);
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companyControl.updateValueAndValidity();
    this.fileExtensionControl.updateValueAndValidity();
    this.generatedFieldsControl.updateValueAndValidity();
    this.generatedFieldsNameControl.updateValueAndValidity();
    this.requireContractDataFields = false;
    this.requireRegistrationDataFields = false;
    this.requireTerminationTypeDataFields = false;
    this.requireContractAnnexDataFields = false;
    this.requireOfwcaApplicationDataFields = false;
    this.requirePartnerDataFields = false;
    this.contractTypeControl.reset();
    this.legalFormControl.reset();
    this.ownerControl.reset();
    this.formOfBusinessControl.reset();
    this.annexControl.reset();
    this.contractTypeControl.reset();
    this.legalFormControl.reset();
    this.ownerControl.reset();
    this.companiesControl.reset();
    this.terminationTypeControl.reset();
    this.formOfBusinessControl.reset();
    this.annexControl.reset();
    this.contractTypeControl.setValidators([]);
    this.ownerControl.setValidators([]);
    this.companiesControl.setValidators([]);
    this.terminationTypeControl.setValidators([]);
    this.formOfBusinessControl.setValidators([]);
    this.legalFormControl.setValidators([]);
    this.annexControl.setValidators([]);
    this.contractTypeControl.updateValueAndValidity();
    this.ownerControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.terminationTypeControl.updateValueAndValidity();
    this.formOfBusinessControl.updateValueAndValidity();
    this.legalFormControl.updateValueAndValidity();
    this.annexControl.updateValueAndValidity();
    this.templateForm.get('startingFieldX').setValidators([]);
    this.templateForm.get('startingFieldX').updateValueAndValidity();
    this.templateForm.get('startingFieldY').setValidators([]);
    this.templateForm.get('startingFieldY').updateValueAndValidity();
  }
  requireAuthorizationData(): void {
    this.requireAuthorizationDataFields = true;
    this.insuranceCompanyControl.setValidators([Validators.required]);
    this.companyControl.setValidators([Validators.required]);
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companyControl.updateValueAndValidity();
    this.requireContractDataFields = false;
    this.requireRegistrationDataFields = false;
    this.requireTerminationTypeDataFields = false;
    this.requireContractAnnexDataFields = false;
    this.requireOfwcaApplicationDataFields = false;
    this.requirePartnerDataFields = false;
    // this.contractTypeControl.reset();
    this.legalFormControl.reset();
    this.ownerControl.reset();
    this.formOfBusinessControl.reset();
    this.annexControl.reset();
    // this.contractTypeControl.reset();
    this.legalFormControl.reset();
    this.ownerControl.reset();
    this.companiesControl.reset();
    this.fileExtensionControl.reset();
    this.generatedFieldsControl.reset();
    this.generatedFieldsNameControl.reset();
    this.generatedFieldsNameControl.setValidators([]);
    this.generatedFieldsNameControl.updateValueAndValidity();
    this.terminationTypeControl.reset();
    this.formOfBusinessControl.reset();
    this.annexControl.reset();
    this.contractTypeControl.setValidators([]);
    this.ownerControl.setValidators([]);
    this.companiesControl.setValidators([]);
    this.generatedFieldsControl.setValidators([]);
    this.fileExtensionControl.setValidators([]);
    this.terminationTypeControl.setValidators([]);
    this.formOfBusinessControl.setValidators([]);
    this.legalFormControl.setValidators([]);
    this.annexControl.setValidators([]);
    this.contractTypeControl.updateValueAndValidity();
    this.ownerControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.generatedFieldsControl.updateValueAndValidity();
    this.fileExtensionControl.updateValueAndValidity();
    this.terminationTypeControl.updateValueAndValidity();
    this.formOfBusinessControl.updateValueAndValidity();
    this.legalFormControl.updateValueAndValidity();
    this.annexControl.updateValueAndValidity();
    this.templateForm.get('startingFieldX').reset();
    this.templateForm.get('startingFieldX').setValidators([]);
    this.templateForm.get('startingFieldX').updateValueAndValidity();
    this.templateForm.get('startingFieldY').reset();
    this.templateForm.get('startingFieldY').setValidators([]);
    this.templateForm.get('startingFieldY').updateValueAndValidity();
  }

  requireOfwcaApplicationData(): void {
    this.requireOfwcaApplicationDataFields = true;
    this.companyControl.setValidators([Validators.required]);
    this.companyControl.updateValueAndValidity();
    this.requireContractDataFields = false;
    this.requireRegistrationDataFields = false;
    this.requireAuthorizationDataFields = false;
    this.requireTerminationTypeDataFields = false;
    this.requireContractAnnexDataFields = false;
    this.requirePartnerDataFields = false;
    this.requireFileConfigurationDataFields = false;
    this.contractTypeControl.reset();
    this.legalFormControl.reset();
    this.ownerControl.reset();
    this.insuranceCompanyControl.reset();
    this.companiesControl.reset();
    this.generatedFieldsControl.reset();
    this.fileExtensionControl.reset();
    this.terminationTypeControl.reset();
    this.formOfBusinessControl.reset();
    this.annexControl.reset();
    this.contractTypeControl.setValidators([]);
    this.ownerControl.setValidators([]);
    this.insuranceCompanyControl.setValidators([]);
    this.companiesControl.setValidators([]);
    this.generatedFieldsControl.setValidators([]);
    this.generatedFieldsNameControl.reset();
    this.generatedFieldsNameControl.setValidators([]);
    this.generatedFieldsNameControl.updateValueAndValidity();
    this.fileExtensionControl.setValidators([]);
    this.terminationTypeControl.setValidators([]);
    this.formOfBusinessControl.setValidators([]);
    this.legalFormControl.setValidators([]);
    this.annexControl.setValidators([]);
    this.contractTypeControl.updateValueAndValidity();
    this.ownerControl.updateValueAndValidity();
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companiesControl.updateValueAndValidity();
    this.generatedFieldsControl.updateValueAndValidity();
    this.fileExtensionControl. updateValueAndValidity();
    this.terminationTypeControl.updateValueAndValidity();
    this.formOfBusinessControl.updateValueAndValidity();
    this.legalFormControl.updateValueAndValidity();
    this.annexControl.updateValueAndValidity();
    this.templateForm.get('startingFieldX').reset();
    this.templateForm.get('startingFieldX').setValidators([]);
    this.templateForm.get('startingFieldX').updateValueAndValidity();
    this.templateForm.get('startingFieldY').reset();
    this.templateForm.get('startingFieldY').setValidators([]);
    this.templateForm.get('startingFieldY').updateValueAndValidity();
  }

  requirePersonalDataChangeFields(): void {
    this.resetRequirements();
    this.insuranceCompanyControl.setValidators([Validators.required]);
    this.companyControl.setValidators([Validators.required]);
    this.insuranceCompanyControl.updateValueAndValidity();
    this.companyControl.updateValueAndValidity();

    this.contractTypeControl.reset();
    this.legalFormControl.reset();
    this.ownerControl.reset();
    this.companiesControl.reset();
    this.generatedFieldsControl.reset();
    this.generatedFieldsNameControl.reset();
    this.fileExtensionControl.reset();
    this.terminationTypeControl.reset();
    this.formOfBusinessControl.reset();
    this.annexControl.reset();

    this.requirePersonalDataChange = true;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (!this.templateForm.valid) {
      this.templateForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.templateForm, this.formErrors);
    this.formErrors = {};

    if (this.generatedFieldsControl.value?.length === 0) {
      this.generatedFieldsControl.setValue(null);
    }
    if (this.generatedFieldsNameControl.value?.length === 0) {
      this.generatedFieldsNameControl.setValue(null);
    }

    this.templateService.sendForm(this.templateForm.getRawValue(), this.templateObject?.uuid)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open(this.templateObject ? 'Pomyślnie zaktualizowano szablon'
          : 'Pomyślnie utworzono szablon', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (this.template) {
          this.closeModification.emit();
        } else {
          if ( window.location.href.includes('rejestracje')){
            this.router.navigate(['/dokumenty/rejestracje/szablony/szczegoly', response.uuid]);
          } else {
            this.router.navigate(['/dokumenty/szablony/szczegoly', response.uuid]);
          }
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open(this.templateObject ? 'Podczas aktualizacji szablonu wystąpił błąd'
          : 'Podczas tworzenia szablonu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.templateForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (this.template) {
      this.closeModification.emit();
    } else {
      if ( window.location.href.includes('rejestracje')){
        this.router.navigate(['/dokumenty/rejestracje/szablony']);
      } else {
        this.router.navigate(['/dokumenty/szablony']);
      }
    }
  }

  add(dict: Dictionary): void{
    if (this.selectedValues.indexOf(dict.key) === -1) {
      this.selectedValues.push(dict.key);
      this.selectedValuesName.push(dict.name);
    }else {
      if (dict.key === GENERATED_FIELDS_SEPARATOR || dict.key === GENERATED_EMPTY) {
        this.selectedValues.push(dict.key);
        this.selectedValuesName.push(dict.name);
      } else {
        this.selectedValues.splice(this.selectedValues.indexOf(dict.key), 1);
        this.selectedValuesName.splice(this.selectedValuesName.indexOf(dict.name), 1);
      }
    }
    this.generatedFieldsControl.setValue(this.selectedValues.toString());
    this.generatedFieldsNameControl.setValue(this.selectedValuesName.toString());

  }

  isSelect(row?: string): boolean {
    let isSelect = false;
    this.selectedValues.forEach((h: string) => {
      if (row === h){
        isSelect = true;
      }
    });
    return isSelect;
  }
  resetForm(): void{
    this.selectedValues = [];
    this.selectedValuesName = [];
    this.generatedFieldsControl.reset();
    this.generatedFieldsNameControl.reset();

  }
  sort(): void {
    this.sortItems. splice(0, this.sortItems.length);
    let x = [];
    let y = 0;
    this.items.forEach((dict: any) => {
      x.push(dict);
      y = y + 1;
      if (y === 2){
        this.sortItems.push(x);
        y = 0;
        x = [];
      }
    });
    this.sortItems.push(x);
  }

  loadItems(dictType: string): void {
    this.dictService.getDictSubject()
      .pipe(
        take(1)
      )
      .subscribe((items: Dictionary[]) => {
        from(items)
          .pipe(
            filter((e: Dictionary) => e.type === dictType),
            tap((e: Dictionary) => {
              if (!this.items.some((search: Dictionary) => search.id === e.id)) {
                this.items.push(e);
              }
            }),
          ).subscribe();
      });
    this.sort();
  }

}
